import { NoDataPage, CircularLoader } from "@components/index";
import { formatCurrency, formatDate } from "@utils/index";
import { isExpired } from "../../vouchersData";
import { tableColumns } from "./VoucherListRenderData";
import "./index.scss";

const VoucherListRender = ({
  vouchers,
  loading,
  error,
  onClearFilters,
  onViewVoucher,
}) => {
  // Show loading state
  if (loading) {
    return (
      <div className="voucher-list-render__loading">
        <CircularLoader
          message="Loading Vochers Data..."
          className="voucher-list-render__loading-container"
        />
      </div>
    );
  }

  // Show table if we have vouchers
  if (vouchers && vouchers.length > 0 && !error) {
    return (
      <div className="voucher-list-render">
        <div className="voucher-list-render__table-container">
          <table className="vouchers-table">
            <thead>
              <tr>
                {tableColumns.map((column) => (
                  <th key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {vouchers.map((voucher, key) => (
                <tr key={key}>
                  <td>
                    <strong className="vouchers-table__code">
                      {voucher.voucher_code}
                    </strong>
                  </td>
                  <td>{voucher.old_pnr_number}</td>
                  <td>{voucher.customer_mobile}</td>
                  <td className="vouchers-table__text-center">
                    {formatCurrency(voucher.voucher_value)}
                  </td>
                  <td>{formatCurrency(voucher.refund_amount)}</td>
                  <td className="vouchers-table__text-center">
                    {formatCurrency(voucher.voucher_redeem_amount)}
                  </td>
                  <td>
                    <span
                      className={
                        isExpired(voucher.voucher_validity)
                          ? "vouchers-table__expired"
                          : ""
                      }
                    >
                      {formatDate(voucher.voucher_validity)}
                    </span>
                  </td>
                  <td>
                    <span
                      className={
                        isExpired(voucher.voucher_validity)
                          ? "vouchers-table__expired"
                          : ""
                      }
                    >
                      {formatDate(voucher.voucher_redemption_date)}
                    </span>
                  </td>

                  <td>
                    <button
                      className="vouchers-table__action-icon vouchers-table__action-icon--view"
                      onClick={() => onViewVoucher(voucher)}
                    >
                      View
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  }

  // Show no data state
  return (
    <div className="voucher-list-render__no-data">
      <NoDataPage
        showRetryButton
        onButtonClick={onClearFilters}
        buttonText={error ? "Retry" : "Reset Filters"}
        message={error ? "Failed to load vouchers data" : "No vouchers found"}
      />
    </div>
  );
};

export default VoucherListRender;
